import React, { useEffect, useState } from 'react';
import { Row, Col, Tooltip, message, Space } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getStockConversionList } from '../ducks/actions'
import { removeStockConversion, bulkRemoveStockConversions } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import dayjs from 'dayjs';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { useTranslate } from 'Translate';

export default (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.inventory.stockConversions);
  const meta = useSelector((state) => state.inventory.stockConversionsOption);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const allowedEdit = allowed([AllRoles.INVENTORY.STOCK_CONVERSION], 'write');
  const allowedDelete = allowed([AllRoles.INVENTORY.STOCK_CONVERSION], 'delete');
  const [outlets, setOutlets] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const searchNetsuiteSynced = queryParameters.get('ns') ? queryParameters.get('ns') == "1" : null;
  const searchOutlet = queryParameters.get('ou');
  const searchDate = queryParameters.get('sd');
  const i18n = useTranslate();
    const { t } = i18n;

  const colName = [
    {
      title: t("Inventory.sc_no"),
      dataIndex: 'reference',
      key: 'reference',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.sc_date"),
      dataIndex: 'date',
      key: 'date',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Outlet.outlet_code"),
      dataIndex: 'location_code',
      key: 'location_code',
      className: 'enable-click',
      sorter: true,
      render: (text, record) =>
        <span>{text} {record?.location_desc}</span>
    },
    {
      title: t("System.remarks"),
      dataIndex: 'remarks',
      key: 'remarks',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.created_by"),
      dataIndex: 'created_by_name',
      key: 'created_by_name',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.posting_date_time"),
      dataIndex: 'posted_at',
      key: 'posted_at',
      className: 'enable-click',
      sorter: true,
      render: (text) => <span>{text || "-"}</span>
    },
    {
      title: t("General.status"),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) =>
        <div className='flex align-items-center'>
          <span className={text === "Posted" ? "c-success" : text === "Pending" ? "c-pending" : "c-danger"}>
            {t(`General.${text?.toLowerCase()}`)}
          </span>
          {" "}
          {
            // allowed([Roles.USERS], 'write') &&
            (text === "Pending" || text === "Posted") &&
            allowedEdit &&
            <Space size={10} >
              {
                (text === "Pending" && record.item_count > 0) &&
                <>
                  {"("}
                    <a className='pointer' onClick={() => onAction(record.id, "post")}>
                      {t("General.post")}
                    </a>
                  {")"}
                </>
              }
              {/* <a className='pointer c-danger' onClick={() => onAction(record.id, "cancel")}>
                Cancel
              </a> */}
            </Space>
          }
          {record?.netsuite_synced === "1" && <Tooltip title={t("Inventory.synced_to_netsuite")}><CheckCircleTwoTone twoToneColor="#52c41a" className="ml-1" /></Tooltip>}
        </div>
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="stock_conversion"
          btnAction1={() => navigate(`/inventory/stock-conversion/${record.id}`)}
          recordId={record.id}
          onRemove={(record?.status === "Pending" && allowedDelete) && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ]

  const addNew = () => navigate('/inventory/stock-conversion/add');

  const btnList = [
    {
      title: t("Confirm.remove_select_stock_conversions"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("New.stock_conversion")}`,
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.stockConvsListQuery) {
      let search = searchVal || {};
      if (searchNetsuiteSynced !== null) {
        search["netsuite_synced"] = searchNetsuiteSynced ? "1" : "0"
      }
      if (searchOutlet) {
        search["outlet"] = searchOutlet;
      }
      if (searchDate) {
        search["date"] = searchDate;
      }

      setSearchVal(search)
      dispatch(getStockConversionList(1, limit, '', '', search, props.setLoading));
      dispatch(getListQueryItems('stockConvsListQuery', 1, limit, '', '', search, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.stockConvsListQuery
      dispatch(getStockConversionList(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  useEffect(() => {
    if(meta) {
      if('locations' in meta) {
        let temp = [];
        meta?.locations?.map((item, index) => {
          if(index === 0) {
            temp.push({
              label: t("General.all_outlets"),
              value: ""
            })
          }
          temp.push({
            label: `${item.code} ${item.desc}`,
            value: item.id
          })
        });
        setOutlets(temp);
      }

      if ("statuses" in meta) {
        let temp2 = [];
        meta.statuses?.map((x, ind) => {
          if (ind === 0) {
            temp2.push({
              label: t("General.all_status"),
              value: ""
            });
          }
          temp2.push({
            label: x,
            value: x
          })
        });
        setStatuses(temp2);
      }
    }
  }, [meta])

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.status !== 'Pending'
    }),
  };

  const onAction = async (poId, status) => {
    onRemove(poId, status)
  }

  const onRemove = async (poId, status = null) => {
    props.setLoading(true);

    const payload = {
      stock_conversion_id: poId,
      status_event: status ? status : 'remove'
    }

    await removeStockConversion(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t(`Success.stock_conversion_${status ? "updated" : "removed"}`));
        setTimeout(() => dispatch(getStockConversionList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('stockConvsListQuery', page, limit, '', '', searchVal, props.setLoading))
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      stock_converesions: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveStockConversions(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Success.remove_stock_conversions"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getStockConversionList(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('stockConvsListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getStockConversionList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('stockConvsListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getStockConversionList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('stockConvsListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    navigate('/inventory/stock-conversion');
    if (search) {
      let searching = {};
      searching = {
        reference: search?.reference,
        status: search.status.value,
        outlet: search?.outlet?.value,
        date: search.date ? dayjs(search.date).format("YYYY-MM-DD") : "",
        netsuite_synced: search?.netsuite_synced?.value
      };
      setSearchVal(searching);
      dispatch(getStockConversionList(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('stockConvsListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getStockConversionList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('stockConvsListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
          navigate(`/inventory/stock-conversion/${record.id}`)
      },
    };
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("General.stock_cons")} btnList={allowedEdit && btnList} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            Search={Search}
            onSearch={onSearch}
            searchVal={globalListQuery.stockConvsListQuery?.searchValue}
            onRow={onClickRow}
            // listClass="nopad"
            ListData={orders?.list?.map(x => ({ ...x, key: x.id }))}
            ListCol={colName}
            rowSelection={allowedEdit && rowSelection}
            onChange={onTableChange}
            pagination={{
              total: orders?.total_count,
              current: page,
              pageSize: limit
            }}
            field1={statuses}
            field2={outlets}
          />
        </Col>
      </Row>
    </>
  )
}